import { createContext, ReactNode } from 'react'

export enum BannerType {
  Migrated = 'migrated',
  Preview = 'preview',
  Danger = 'danger',
}

export interface TopBannerDismissedProps {
  isDismissed: boolean
}

export interface TopBannerProps {
  message: string | ReactNode
  id: string
  visible: boolean
  accountKey?: string | null
  closable?: boolean
  dismissed?: boolean
  onClose?: () => void
  variant?: string
  icon?: ReactNode
  action?: ReactNode
}
export interface BannerProps {
  id: string
  visible: boolean
  message: string
  accountKey?: string | null
  closable?: boolean
  variant?: string
  icon?: ReactNode
  action?: ReactNode
}

export interface TopBarBannerContext {
  topBanner: TopBannerProps | null
  dismissBanner: () => void
}

export default createContext<TopBarBannerContext>({
  topBanner: null,
  dismissBanner: () => {},
})
